import React from "react";
import { useAppTranslation } from "../../../../../../../../../i18n/useAppTranslation";
import { Button } from "../../../../../../../../../shared/Button/Button";
import { useTogglePublish } from "../../../../../hooks/useTogglePublish";
import { CircularProgress } from "../../../../../../../../../shared/CircularProgress/CircularProgress";
import { useContext } from "../../../../../context";

export const Publish = () => {
  const { tSettings: t } = useAppTranslation.Settings({
    keyPrefix: "survey",
  });

  const togglePublish = useTogglePublish();
  const { isError } = useContext();

  return (
    <Button
      size="small"
      variant="outlined"
      onClick={togglePublish.initiate}
      isDisabled={togglePublish.isLoading || isError}
      leftAdornment={
        togglePublish.isLoading ? (
          <CircularProgress size="small" color="primary" />
        ) : undefined
      }
    >
      {t("action.publish")}
    </Button>
  );
};
